/* eslint-disable */
import sendRequest from "../../resources/js/utils/sendRequest";
import {qs} from "../../resources/js/utils/dom";

document.addEventListener('DOMContentLoaded', () => {
  const section = qs('[data-posts-grid-section-js]');
  const grid = qs('[data-posts-grid-js]');
  const loadMoreEl = qs('[data-load-more-js]');
  const maxNumPages = grid.getAttribute('data-max-num-pages-js');
  const postsPerPage = grid.getAttribute('data-posts-per-page-js');

  loadMoreEl.addEventListener('click', function () {
    let paged = +grid.getAttribute('data-paged-js');
    paged++;

    if (paged <= maxNumPages) {
      grid.setAttribute('data-paged-js', `${paged}`);
      grid.parentElement.classList.add('loading');

      getPosts(postsPerPage, paged).then(function (data) {
        grid.innerHTML += data.html;
        section.classList.toggle('all-loaded', data.allLoaded);
        section.classList.toggle('nothing-found', data.nothingFound);
        grid.parentElement.classList.remove('loading');
      });
    }
  });

  async function getPosts(postsPerPage, paged) {
    const formData = new FormData();
    formData.append('postsPerPage', postsPerPage);
    formData.append('paged', paged);

    const response = await sendRequest({method: 'POST', data: formData, endpoint: 'posts'});
    const data = await response.data;

    return data;
  }
});

